export enum SmevMonitoringActionsEnum {
  SMEV_MONITORING_INIT_PAGE = 'SMEV_MONITORING_INIT_PAGE',
  SMEV_MONITORING_SET_ORDER = 'SMEV_MONITORING_SET_ORDER',
  SMEV_MONITORING_GET_TABLE_DATA = 'SMEV_MONITORING_GET_TABLE_DATA',
  SMEV_MONITORING_GET_TABLE_DATA_NEXT_PAGE = 'SMEV_MONITORING_GET_TABLE_DATA_NEXT_PAGE',
  SMEV_MONITORING_SET_TABLE_DATA = 'SMEV_MONITORING_SET_TABLE_DATA',
  SMEV_MONITORING_GET_SYSTEM_TYPES = 'SMEV_MONITORING_GET_SYSTEM_TYPES',
  SMEV_MONITORING_GET_MESSAGE_TYPES = 'SMEV_MONITORING_GET_MESSAGE_TYPES',
  SMEV_MONITORING_GET_SERVICE_TYPES = 'SMEV_MONITORING_GET_SERVICE_TYPES',
  SMEV_MONITORING_GET_ENDPOINTS = 'SMEV_MONITORING_GET_ENDPOINTS',
  SMEV_MONITORING_SET_SYSTEM_TYPES = 'SMEV_MONITORING_SET_SYSTEM_TYPES',
  SMEV_MONITORING_GET_SYSTEM_CHARTS = 'SMEV_MONITORING_GET_SYSTEM_CHARTS',
  SMEV_MONITORING_SET_MESSAGE_TYPES = 'SMEV_MONITORING_SET_MESSAGE_TYPES',
  SMEV_MONITORING_SET_SERVICE_TYPES = 'SMEV_MONITORING_SET_SERVICE_TYPES',
  SMEV_MONITORING_SET_ENDPOINTS = 'SMEV_MONITORING_SET_ENDPOINTS',
  SMEV_MONITORING_SET_FILTER = 'SMEV_MONITORING_SET_FILTER',
  SMEV_MONITORING_GET_CHARTS = 'SMEV_MONITORING_GET_CHARTS',
  SMEV_MONITORING_SET_CHARTS = 'SMEV_MONITORING_SET_CHARTS',
  SMEV_MONITORING_SET_ADDITIONAL_CHARTS = 'SMEV_MONITORING_SET_ADDITIONAL_CHARTS',
  SMEV_MONITORING_SET_FILTER_FORM = 'SMEV_MONITORING_SET_FILTER_FORM',
  SMEV_MONITORING_GET_MESSAGE_BY_ID = 'SMEV_MONITORING_GET_MESSAGE_BY_ID',
  SMEV_MONITORING_SET_MESSAGE_BY_ID = 'SMEV_MONITORING_SET_MESSAGE_BY_ID',
  SMEV_MONITORING_DOWNLOAD_MESSAGE = 'SMEV_MONITORING_DOWNLOAD_MESSAGE',
  SMEV_MONITORING_GET_PROCESSING_STATUSES = 'SMEV_MONITORING_GET_PROCESSING_STATUSES',
  SMEV_MONITORING_GET_SENDING_STATUSES = 'SMEV_MONITORING_GET_SENDING_STATUSES',
  SMEV_MONITORING_SET_PROCESSING_STATUSES = 'SMEV_MONITORING_SET_PROCESSING_STATUSES',
  SMEV_MONITORING_SET_SENDING_STATUSES = 'SMEV_MONITORING_SET_SENDING_STATUSES',
  SMEV_MONITORING_RESET_ADDITIONAL_CHARTS = 'SMEV_MONITORING_RESET_ADDITIONAL_CHARTS',
  SMEV_MONITORING_GET_CHARTS_WITH_ENDPOINTS = 'SMEV_MONITORING_GET_CHARTS_WITH_ENDPOINTS',
  SMEV_MONITORING_SET_LOADING_ADDITIONAL_CHARTS = 'SMEV_MONITORING_SET_LOADING_ADDITIONAL_CHARTS',
  SMEV_MONITORING_GET_SENDERS = 'SMEV_MONITORING_GET_SENDERS',
  SMEV_MONITORING_SET_SENDERS = 'SMEV_MONITORING_SET_SENDERS',
  SMEV_MONITORING_GET_SMEV_MESSAGE_TYPES = 'SMEV_MONITORING_GET_SMEV_MESSAGE_TYPES',
  SMEV_MONITORING_SET_SMEV_MESSAGE_TYPES = 'SMEV_MONITORING_SET_SMEV_MESSAGE_TYPES',
}
